import script from "./EscalaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EscalaTable.vue?vue&type=script&setup=true&lang=js"

import "./EscalaTable.vue?vue&type=style&index=0&id=1384347e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1384347e"]])

export default __exports__